module.exports = __webpack_public_path__ + "img/img-flow-2.3b3d08c4.png";